import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';
import { Paper, Tabs, Tab, makeStyles } from '@material-ui/core';
import { TabPanel } from '../components/TabPanel';

import Gateway from './Gateway';
import GatewaysBacklog from './Gateways/GatewaysBacklog';
import GatewaysInOperation from './Gateways/GatewaysInOperation';
import GatewaysDsp from './Gateways/GatewaysDsp';
import GatewaysAll from './Gateways/GatewaysAll';
import useLocalStorage from 'react-use-localstorage';
import useSearchQuery from '../lib/search-query';
import GatewayModel from '../model/gateway';

const useStyles = makeStyles((theme) => ({
  navTabWide: {
    whiteSpace: 'nowrap',
    minWidth: '22rem'
  },
}));

const Content = ({ match }) => {
  const query = useSearchQuery();
  const classes = useStyles();
  const [visibleTabIndexStr, setVisibleTabIndex] = useLocalStorage(
    'gateways-active-tab',
    '0',
  );
  const visibleTabIndex = +visibleTabIndexStr || 0;
  const { t } = useTranslation(['gateway']);

  const onTabChange = (event, tabIndex) => {
    setVisibleTabIndex(tabIndex);
  };

  useEffect(() => {
    if (query.get(GatewayModel.buildingAddress)) {
      setVisibleTabIndex('0');
    }
  }, []);

  return (
    <Paper>
      <Tabs
        indicatorColor="primary"
        textColor="primary"
        value={visibleTabIndex}
        onChange={onTabChange}>
        <Tab label={t('gateway:All Gateways')} />
        <Tab label={t('gateway:Gateways sending directly')} />
        <Tab label={t('gateway:Gateways sending indirectly (over DSP)')} className={classes.navTabWide} />
        <Tab label={t('gateway:Backlog')} />
      </Tabs>
      <TabPanel value={visibleTabIndex} index={0}>
        <GatewaysAll match={match} />
      </TabPanel>
      <TabPanel value={visibleTabIndex} index={1}>
        <GatewaysInOperation match={match} />
      </TabPanel>
      <TabPanel value={visibleTabIndex} index={2}>
        <GatewaysDsp match={match} />
      </TabPanel>
      <TabPanel value={visibleTabIndex} index={3}>
        <GatewaysBacklog match={match} />
      </TabPanel>
    </Paper>
  );
};

export default function Gateways({ match }) {
  return (
    <Switch>
      <Route exact path={match.path} component={Content} />
      <Route path={`${match.path}/new`} component={Gateway} />
      <Route path={`${match.path}/:id`} component={Gateway} />
    </Switch>
  );
}
